import React from 'react'
import LabelParameters from '../LabelParameters'
import styles from '../CreateParameterPopup.module.css'
const Percentage = ({parameterData, handleChange,editingInput,setEditingInput}) => {
  return (
    <div>
           <LabelParameters value={parameterData.percentage} text={'percentage'} editingInput={editingInput} setEditingInput={setEditingInput} >
   <div className={styles.percentageContainer}>
   <input
        name="textbox"
        value={parameterData.percentage}
        onChange={handleChange}
        placeholder={'00.00'}
      />
   </div>
</LabelParameters>
    </div>
  )
}

export default Percentage